import React from "react";

import Style from "../style";
import { Grid } from "@material-ui/core";

import Android from "../assets/android-notification.png";
import NoticeIcon from "../assets/icon.svg";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import * as ScreenText from "../../../../consts/ScreenText.js";

export default function NoticePreview( { title, body, url, category, subCategory, image, loadingImage } ) {
  
  const [expanded, setExpanded] = React.useState(false);

  const style = Style();

  const getTitle = () => {
    if (!title) return ScreenText.NOTIFICATIONS_CELLPHONE_TITLE;
    return title;
  };

  const getBody = () => {
    if (!body) return ScreenText.NOTIFICATIONS_CELLPHONE_BODY;
    return body;
  };

  const getHeader = () => {
    if (category) {
      if (subCategory && subCategory.name) 
        return "Ayacucho · " + category.name + " · " + subCategory.name;
      else
        return "Ayacucho · " + category.name;
    } else {
      return "Ayacucho · Categoría";
    }
  }

  return (
    <div className={style.cellPhone}>
      <img src={Android} alt=""/>
      <Paper className={style.notification} >
        <Grid container spacing={1} style={{paddingBottom: 6}}>
          <Grid item xs={12} style={{textAlign: 'left'}}>
            <Grid container>
              <Grid item xs={true}>
                <img src={NoticeIcon} style={{ marginLeft: -3, height: 20}} alt=""/>
                <span style={{marginLeft: 4, fontSize: 10, color: 'gray' }}>{getHeader()}</span>
              </Grid>
              <Grid item>
                  { expanded ? (
                    <ExpandLessRoundedIcon fontSize="small" onClick={() => setExpanded(false)}/>
                  ) : (
                    <ExpandMoreRoundedIcon fontSize="small" onClick={() => setExpanded(true)}/>
                  )}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={true}>
            <span className={ !expanded && style.ellipseableText } style={{ 'WebkitLineClamp': 1 }}>
              <Typography className={style.title}>
                { getTitle() }
              </Typography>
            </span>
            <span className={ !expanded && style.ellipseableText } style={{ 'WebkitLineClamp': 1 }}>
              <Typography className={style.body}>
              { getBody() }
              </Typography>
            </span>
          </Grid>
          <Grid item >
            { image && (
              <img src={image} className={style.image} alt=""/>
            )}
          </Grid>
        </Grid>
      </Paper>
    </div>
  );
}
